import React from "react";
import { Route, Redirect } from "react-router-dom";


// class HrefRedirect extends React.Component {
//   componentDidMount() {
//     if (this.props.url) {
//       window.location.href = this.props.url;
//     }
//   }
//   render() {
//     return <div className=""></div>
//   }
// }

const AuthRoute = ({ component: C, props: cProps, ...rest }) =>
  <Route
    {...rest}
    render={props =>
      cProps.isLogin
        ? <C {...props} {...cProps} />
        // :
        // (cProps.wxQuery&&cProps.wxQuery.entity) ?
        //   <C {...props} {...cProps} />
        : <Redirect
          to={`/login?redirect=${props.location.pathname}${props.location
            .search}`}
        />}
  // render={props => {
  //   console.log('get props', cProps)
  //   if (cProps.isLogin) {
  //     return <C {...props} {...cProps} />
  //   } else {
  //     try {
  //       window.localStorage.removeItem('token')
  //     } catch (e) {
  //       console.log('remove error', e)
  //     }

  //     return <HrefRedirect url={`https://${window.location.host}/wechatAuth.html?redirect=${encodeURIComponent(props.location.pathname + props.location.search)}`} />
  //   }
  //   // return <C {...props} {...cProps} />
  // }}
  />;


export default AuthRoute;